import { loadScript } from '../loadScriptFn'
import { currentLang } from '../localization/currentLang'

const head = document.querySelector('head')

if (head && currentLang === 'aa') {
  const script = document.createElement('script')

  // eslint-disable-next-line quotes
  script.innerHTML = "var _jipt = []; _jipt.push(['project', 'zomrosite'])"

  head.appendChild(script)
  loadScript('//cdn.crowdin.com/jipt/jipt.js')
}
